//
// Progress through the active pathway, derived from where the current step
// sits in the pathway's own node order (not from how many answers have been
// stored, which jumps after Back). Auto-advancing nodes are not steps.
//

interface ProgressNode {
  id: string;
}

/**
 * 0-100. A visible node at position i of N reports i/N (so the first screen is
 * 0% and the last is below 100%); a node outside the list (an outcome) is 100.
 * If the current node is unknown to the list, falls back to the answered ratio.
 */
export function pathwayProgressPercent(
  nodes: ProgressNode[],
  currentNodeId: string,
  isAutoAdvance: (node: any) => boolean,
  answeredVisibleCount = 0,
): number {
  const visible = nodes.filter((n) => !isAutoAdvance(n));
  if (visible.length === 0) return 0;
  const idx = visible.findIndex((n) => n.id === currentNodeId);
  const raw = idx >= 0 ? (idx / visible.length) * 100 : nodes.some((n) => n.id === currentNodeId) ? (answeredVisibleCount / visible.length) * 100 : 100;
  return Math.max(0, Math.min(100, raw));
}
